export default "__VITE_ASSET__Ehk7tQME__"